import { PureConnect, React } from '../../react';

import selectors from './selectors';

import SELECTION_CHANGE_ISNOTE from './actions/CHANGE_ISNOTE';

import cx from './style.less';
import { usergroupResource } from '../../usergroup/resource';
import { beheerResource } from '../../admin/resource';
import adminReselectors from '../admin/reselectors';
import { canCreateQuestion, statusses } from '../question/authmodule/authcheck';

export default PureConnect('NoteSelection')(
    (state) => ({
        selection: selectors.selection(state),
        textselection: selectors.text(state),
        isnote: selectors.isnote(state),
        valid: !!state.selection.selection,
        visible: state.selection.creating,
        usergroups: usergroupResource.selectors.items(state),
        participants: adminReselectors.participantsSelector(state),
	    beheer: beheerResource.selectors.items(state),
        origin: state.notemenu.origin,
        buttonNo: state.notemenu.buttonNo,
    }),
    (dispatch) => ({
         onChangeIsNote(event: any) { return dispatch(SELECTION_CHANGE_ISNOTE({ isnote: event!=='question' }));},
    }),
    ({ visible, textselection, isnote, onChangeIsNote, beheer, participants, usergroups }) => {

        const currentUser =  participants.qWhere((i)=>i.isUser).qFirst();        
        const currentUserId =  currentUser ? currentUser.id: '';  
        var admin = beheer && beheer.qFirst();
        // canChange
        var canCreate = canCreateQuestion(statusses, currentUserId, usergroups, admin);
        return (                   
            <div className={cx('select-kind-note-container',(!visible) ? 'wcag-invisible' : '')}  
                    aria-hidden={!visible} 
                    aria-labelledby= "Selecteer een stuk tekst">
                <div className={cx('select-kind-of-note')}>1. Selecteer soort notitie</div>
                <div className={cx('wrapper')}>
                    <input type="radio" name="select" id="option-1" value={'note'} checked={isnote} onChange={()=> null}/>
                    <input type="radio" name="select" id="option-2" value={'question'} checked={!isnote} onChange={()=> null}/>
                    <label tabIndex={0} className={cx('option', 'option-1', isnote?'active':'')} onClick={()=> onChangeIsNote('note')}>
                        <div className={cx('dot','option_icon')} data-icon="icon_message-text"></div>
                        <span>Notitie</span>
                        </label>
                    {canCreate ? <label tabIndex={0} className={cx('option', 'option-2', !isnote?'active':'')} onClick={()=> onChangeIsNote('question')}>
                        <div className={cx('dot','option_icon')} data-icon="icon_comment-question"></div>
                        <span>Technische Vraag</span>
                    </label> : null}
                </div>
                <div className={cx('select-tekst')}>2. Selecteer een stuk tekst en klik op bevestigen</div>
                <div className={cx('selected-container')}>
                    <span className={cx('selected-text_title')}>Geselecteerde tekst:</span>
                    <span className={cx('selected-text')}>{textselection.length > 0 ? textselection : 'Nog geen tekst geselecteerd.' }</span>
                </div>
            </div>
        );
    },
);



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/selection/selection.tsx